import { InfoAlert } from '../../features/Alerts/InfoAlert';
import { Modal } from '../Modal';
import React, { FC, MouseEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SpirsType, StoreType } from '../../../store/spirs/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ModalType } from './ModalType';

interface NoAuthOrMoneyModalProps {
    modalType: ModalType;
    outsideIsOpen?: boolean;
    outsideClose?: () => void;
}

type PlayerStatusProps = Pick<
    SpirsType,
    | 'playerIdentified'
    | 'playerIdentifiedLoaded'
    | 'playerHasAccounts'
    | 'playerAccountsLoaded'
    | 'playerAuthenticated'
    | 'playerAuthenticatedLoaded'
>;

export const NoAuthOrMoneyModal: FC<NoAuthOrMoneyModalProps> = ({ modalType, outsideIsOpen = false, outsideClose }) => {
    const {
        playerIdentified,
        playerIdentifiedLoaded,
        playerHasAccounts,
        playerAccountsLoaded,
        playerAuthenticated,
        playerAuthenticatedLoaded
    } = useSelector((state: StoreType) => state.spirs);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');

    const getMessage = (messageProps: PlayerStatusProps) => {
        const playerIdentifiedAndLoad = messageProps.playerIdentified && messageProps.playerIdentifiedLoaded;
        const playerAuthenticatedAndLoad = messageProps.playerAuthenticated && messageProps.playerAuthenticatedLoaded;
        const notAuthenticated = !messageProps.playerAuthenticated && messageProps.playerAuthenticatedLoaded;
        const notIdentified =  playerAuthenticatedAndLoad && !messageProps.playerIdentified || !messageProps.playerIdentifiedLoaded;
        const noAccounts = !messageProps.playerHasAccounts && messageProps.playerAccountsLoaded;
        switch (modalType) {
            case ModalType.COUPONS:
                return playerAuthenticatedAndLoad && notIdentified
                    ? t('coupons.saveNotIdentified')
                    : playerAuthenticatedAndLoad && playerIdentifiedAndLoad && noAccounts
                    ? t('coupons.noAccounts')
                    : '';
            case ModalType.MY_BETS:
                return notAuthenticated
                    ? t('myBets.unauthorizedUserMessage')
                    : notIdentified
                    ? t('myBets.notIdentifiedMessage')
                    : noAccounts
                    ? t('myBets.hasNotAccountsMessage')
                    : '';
            default:
                return '';
        }
    };

    const handleOpenModal = () => {
        if (modalType === ModalType.COUPONS) {
            setIsModalOpen(outsideIsOpen);
        } else {
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        if (modalType === ModalType.COUPONS && outsideClose) {
            outsideClose();
        } else {
            setIsModalOpen(false);
        }
    };

    useEffect(() => {
        return () => {
            handleCloseModal();
        };
    }, []);

    useEffect(() => {
        setMessage(
            getMessage({
                playerAuthenticated,
                playerAuthenticatedLoaded,
                playerIdentified,
                playerIdentifiedLoaded,
                playerHasAccounts,
                playerAccountsLoaded
            })
        );
    }, [
        playerAuthenticated,
        playerIdentifiedLoaded,
        playerIdentified,
        playerIdentifiedLoaded,
        playerHasAccounts,
        playerAccountsLoaded
    ]);

    useEffect(() => {
        console.log('Определение сообщения:', {
            playerAuthenticated,
            playerAuthenticatedLoaded,
            playerIdentified,
            playerIdentifiedLoaded,
            playerHasAccounts,
            playerAccountsLoaded,
            message: message || 'Нет сообщения',
            shouldShowDepositButton:
                playerAuthenticated &&
                playerAuthenticatedLoaded &&
                playerIdentified &&
                playerIdentifiedLoaded &&
                !playerHasAccounts &&
                playerAccountsLoaded
        });

        if (message !== '') {
            handleOpenModal();
        }
    }, [message]);

    const handleGoPayment = (
        e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        handleCloseModal();

        navigate('/balance/replenishment');
    };

   const handleGoIdentification = (
       e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
   ) => {
       e.preventDefault();
       e.stopPropagation();
       handleCloseModal();

       navigate('/identification/passport');
   };

    return (
        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
            <div className="flex flex-col w-full">
                <div className="flex mb-[15px]">
                    <InfoAlert>{message}</InfoAlert>
                </div>
                <div className="flex justify-end gap-[12px]">
                    {playerAuthenticated &&
                        playerIdentified &&
                        !playerHasAccounts &&
                        playerAccountsLoaded && (
                            <button
                                id="toast-deposit-button"
                                className="px-[12px] py-[8px] font-['Roboto'] bg-[#EACD40] rounded-[4px] text-[#121518] text-[14px] font-normal tracking-[0.63px]  hover:bg-[#d4b830] hover:shadow-md transition-all duration-200"
                                onClick={handleGoPayment}
                            >
                                {t('myBets.deposit')}
                            </button>
                        )}
                    {(playerAuthenticated && playerAuthenticatedLoaded && (!playerIdentified || !playerIdentifiedLoaded)) && (
                        <button
                            id="toast-deposit-button"
                           className="px-[12px] py-[8px] font-['Roboto'] bg-[#EACD40] rounded-[4px] text-[#121518] text-[14px] font-normal tracking-[0.63px]  hover:bg-[#d4b830] hover:shadow-md transition-all duration-200"
                           onClick={handleGoIdentification}
                       >
                           {t('myBets.identification')}
                       </button>
                    )}
                    <button
                        className="border border-white rounded-[4px] px-[25px] py-[8px] text-[14px] hover:bg-[#484E55]"
                        onClick={handleCloseModal}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};
